const state = {
    issues: [],
    active: false,
}

export function startImportSession() {
    state.issues = []
    state.active = true
}

export function endImportSession() {
    state.active = false
}

export function reportImportIssue(severity, message, detail = null) {
    if (!state.active) return
    state.issues.push({ severity, message, detail })
}

export function getImportIssues() {
    return [...state.issues]
}
